import React, { useMemo } from 'react';

import { useTranslation } from 'react-i18next';
import { ALERT_TYPES, TaskCancelationReason } from '@bringg/types';

import { useStores } from '../../../recipes';
import { workflowsRootStore } from 'bringg-web/features/automation-workflows/stores/workflows-root-store';

interface Props {
	extraData: { reason?: string; errorMessage?: string; task_id?: number; custom_title?: string };
	alertType: ALERT_TYPES;
}

const AlertNameCell = ({ extraData = {}, alertType }: Props) => {
	const { t } = useTranslation();
	const { alertsStore } = useStores();
	const { workflowAlertsStore } = workflowsRootStore.getStore();

	const text = useMemo(() => {
		const customAlert = workflowAlertsStore.getAlertById(alertType);

		if (extraData?.custom_title) {
			return extraData.custom_title;
		}

		if (customAlert) {
			return customAlert.title;
		}
		let reason: string | TaskCancelationReason = 'Unknown';
		switch (alertType) {
			case ALERT_TYPES.VRP_AUTO_DISPATCH_FAILED_TO_ASSIGN_TASK:
				if (extraData?.reason) {
					reason = t(`ROUTE_OPTIMIZATION_FAILED_TO_ASSIGNED_REASONS.${extraData.reason}`, extraData); // added extra data in case need nesting fields
				}
				return t('ALERTS.VRP_AUTO_DISPATCH_FAILED_TO_ASSIGN_TASK', { reason });
			case ALERT_TYPES.DRIVER_CANCELLED_ORDER:
				reason = alertsStore.getTasks.get(extraData.task_id)?.task_cancellation_reason;
				if (reason) {
					return t('ALERT_TYPES.DRIVER_CANCELLED_ORDER_WITH_REASON', { reason });
				}
				return t(`ALERT_TYPES.DRIVER_CANCELLED_ORDER`);
			case ALERT_TYPES.ROUTE_OPTIMIZATION_FAILED: {
				// TODO: use on BE the same reason key, as it vary depending on ALERT_TYPE
				let errorMessage = reason;

				if (extraData?.errorMessage) {
					// eslint-disable-next-line prefer-destructuring
					errorMessage = extraData.errorMessage;
				} else if (extraData?.reason) {
					errorMessage = t(`ROUTE_OPTIMIZATION_FAILED_TO_ASSIGNED_REASONS.${extraData.reason}`, extraData);
				}

				return t(`ALERTS.ROUTE_OPTIMIZATION_FAILED`, { errorMessage });
			}
			default:
				return ALERT_TYPES[alertType] ? t(`ALERT_TYPES.${ALERT_TYPES[alertType]}`) : t(`GLOBAL.NA`);
		}
	}, [extraData]);

	return <span title={text}>{text}</span>;
};

export default AlertNameCell;
